// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_overlay {
  background: rgba(0, 0, 0, 0.542);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 101;
}

.table_modal {
  position: fixed;
  margin: auto;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  z-index: 102;
  display: flex;
  justify-content: center;
}

.modal_section {
  background: white;
  width: 90%;
  max-width: 1100px;
  padding: 20px;
  border-radius: 5px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.modal_section .modal_title {
  padding: 10px 0;
  font-size: 20px;
  font-weight: 600;
}

.close_button_modal img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.modal_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.27);
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/index.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,kCAA0B;UAA1B,0BAA0B;EAC1B,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,MAAM;EACN,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C","sourcesContent":[".modal_overlay {\r\n  background: rgba(0, 0, 0, 0.542);\r\n  backdrop-filter: blur(4px);\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 101;\r\n}\r\n\r\n.table_modal {\r\n  position: fixed;\r\n  margin: auto;\r\n  bottom: 0;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 102;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.modal_section {\r\n  background: white;\r\n  width: 90%;\r\n  max-width: 1100px;\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n.modal_section .modal_title {\r\n  padding: 10px 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.close_button_modal img {\r\n  cursor: pointer;\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n.modal_header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.27);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
